import { render } from "./ReviewPost.vue?vue&type=template&id=6677c8a2&scoped=true"
import script from "./ReviewPost.vue?vue&type=script&lang=js"
export * from "./ReviewPost.vue?vue&type=script&lang=js"

import "./ReviewPost.vue?vue&type=style&index=0&id=6677c8a2&lang=scss&scoped=true"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6677c8a2"]])

export default __exports__